<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ format == 'upload' ? 'Validate Technical Documents' : 'Receipt of Bids'}}</h4>
        <h5 class="text-primary">[{{ proposalName }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>
        <!-- 
        <ng-container *ngIf="
            stepDetails?.is_initiator ||
            stepDetails?.is_approver ||
            stepDetails?.is_recommender ||
            (stepDetails?.step_status != 'approved' && userID == 6)
          ">
          <button
            class="btn btn-primary me-2"
            (click)="onSubmit()"
           
          >
            <i class="pi pi-save me-1"></i> Submit
          </button>
        </ng-container> -->

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />
  <p-accordion [multiple]="true">
    <p-accordionTab *ngFor="let vendor of vendors">
      <ng-template pTemplate="header">
        <div class="d-flex justify-content-between align-items-center" style="width: 100%">
          <div>
            <strong>{{ vendor.vendor.name }} - </strong>
            <span *ngIf="vendor.vendor_status" class="p-ml-2" [ngClass]="{
                  'text-success': vendor.vendor_status === 'Qualified',
                  'text-danger': vendor.vendor_status === 'Disqualified'
                }">
              ({{ vendor.vendor_status }})
            </span>
          </div>
          <div class="d-flex gap-3" *ngIf="format =='upload' ">
            <button class="p-button-success p-mr-2" (click)="setStatus(vendor, 'Qualified')"> Qualify </button>
            <button class="p-button-danger" (click)="setStatus(vendor, 'Disqualified')"> Disqualify</button>
          </div>
        </div>
      </ng-template>


      <div *ngIf="vendor.vendor.document.length > 0">
        <h5>Uploaded Files</h5>
        <ul>
          <li *ngFor="let doc of vendor.documents">
            <a [href]="apiUrl + doc.fileId" [attr.download]="doc.fileName" target="_blank">
              {{ doc.fileName }}
            </a>
          </li>
        </ul>
      </div>
      <div *ngIf="vendor.vendor.document.length === 0">
        <p>No files uploaded yet.</p>
      </div>

    </p-accordionTab>
  </p-accordion>
</div>